import React from "react";
import { Route, Routes } from "react-router-dom";
import config from "./config";
import MsalAuth from "./Auth/MsalAuth";
import SignIn from "./SignIn";
import Login from "./Login";
import Logout from "./Logout";
import NotFound from "./common/components/NotFound";
import { strings } from "./common/i18n";
import SystemBanner from "./common/components/SystemBanner";

/**
 * App Routes Component
 */
const paths = {
    auth: `/${config.paths.auth}`,
    signIn: `/${config.paths.signIn}`,
    login: `/${config.paths.login}`,
    logout: `/${config.paths.logout}`
};

export default () => {
    return (
        <>
            <SystemBanner scenario />
            <Routes>
                <Route
                    path="*"
                    element={
                        <NotFound message={strings("messages.pageNotFound")} />
                    }
                />

                <Route path="/" element={<Login />} />
                <Route path={paths.login} element={<Login />} />
                <Route path={`${paths.auth}/*`} element={<MsalAuth />} />
                <Route path={paths.signIn} element={<SignIn />} />
                <Route path={paths.logout} element={<Logout />} />
            </Routes>
        </>
    );
};

/* Values for SystemBanner
 1. outage
 2. releases
 3. maintenance
 */
